import React, { useContext, useState } from "react";
import { GlobalContext } from "../Context/GlobalContext";
import storage from "../Assets/js/Global";

const ChangePassword = () => {
  const {
    email,
    sendEmailOTP,
    translatedLabels,
    updateUserData,
    timer,
    resendDisabled,
    resetPassword,
    userData,
    verifyOTP,
    resendEmailOTP,
    showPasswords,
    togglePassword,
  } = useContext(GlobalContext);
  const user = storage.get("loginObj");
  const [showOTPSection, setShowOTPSection] = useState(false);
  const [showPassSection, setShowPassSection] = useState(false);
  const authLabel = translatedLabels?.auth;

  const handleSendOTP = async () => {
    const success = await sendEmailOTP();
    if (success) {
      setShowOTPSection(true);
    }
  };

  const handleVerifyOTP = async () => {
    const success = await verifyOTP();

    if (success) {
      setShowOTPSection(false);
      setShowPassSection(true);
    }
  };
  return (
    <div className="content-part">
      {!showOTPSection && !showPassSection && (
        <div>
          <div className="form-group mb-2">
            <label className="form-label">
              {authLabel?.email?.label_value || "Email"}
            </label>
            <input
              type="email"
              className="form-control wrInputText"
              placeholder={
                authLabel?.enter_email?.label_value || "Enter e-mail"
              }
              value={email || user?.userEmail}
              disabled
            />
          </div>
          <div className="mt-4 text-center">
            <button onClick={handleSendOTP} className="btn btn-primary">
              {authLabel?.submit?.label_value || "Submit"}
            </button>
          </div>
        </div>
      )}

      {showOTPSection && !showPassSection && (
        <div className="">
          <h3 className="text-center mb-4">
            {authLabel?.verification_code?.label_value || "Verification Code"}
          </h3>
          <div className="form-group text-center">
            <p className="form-label">
              <span>{authLabel?.your_email?.label_value || "Your Email"}</span>:{" "}
              <span className="fw-semibold">{email || user?.userEmail}</span>
            </p>
          </div>
          <p className="text-center fs-14px text-muted">
            {authLabel?.enter_email_code?.label_value ||
              "Please enter the 6-digit code sent to your email"}
          </p>
          <div className="otp-container">
            <input
              type="text"
              maxLength="6"
              className="otp-input"
              placeholder="------"
              value={userData?.otp || ""}
              onChange={(e) => updateUserData("otp", e.target.value)}
            />
          </div>
          <p className="fw-semibold text-center">
            {authLabel?.didnt_receive_code?.label_value ||
              "Didn’t receive the verification code?"}
            <span
              onClick={resendEmailOTP}
              className="ms-1 text-decoration-none fw-semibold text-primary"
              style={{
                cursor: resendDisabled ? "not-allowed" : "pointer",
                opacity: resendDisabled ? 0.6 : 1,
                pointerEvents: resendDisabled ? "none" : "auto",
              }}
            >
              {authLabel?.resend?.label_value || "Resend"}
            </span>
          </p>
          {resendDisabled && (
            <p className="text-center fst-italic timer-part">
              {authLabel?.resend_otp_in?.label_value || "Resend OTP in"}{" "}
              <span className="fw-semibold text-primary">
                00:{timer < 10 ? `0${timer}` : timer} Sec
              </span>
            </p>
          )}
          <div className="mt-4 text-center">
            <button
              type="button"
              onClick={handleVerifyOTP}
              className="btn btn-primary"
            >
              {authLabel?.confirm?.label_value || "Confirm"}
            </button>
          </div>
        </div>
      )}

      {showPassSection && (
        <div>
          <div className="form-group mb-2">
            <div className="position-relative">
              <label className="form-label">
                {authLabel?.new_password?.label_value || "New Password"}{" "}
                <span className="text-danger">*</span>
              </label>
              <input
                type={showPasswords.field1 ? "text" : "password"}
                name="password1"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_password?.label_value || "Enter Password"
                }
                required
                value={userData?.setPassword}
                onChange={(e) => updateUserData("setPassword", e.target.value)}
              />
              <span
                className="toggle-password position-absolute eye-icon"
                onClick={() => togglePassword("field1")}
              >
                <i
                  className={`fa ${showPasswords.field1 ? "fa-eye" : "fa-eye-slash"
                    }`}
                ></i>
              </span>
            </div>
          </div>

          <div className="form-group mb-2">
            <div className="position-relative">
              <label className="form-label">
                {authLabel?.confirm_password?.label_value || "Confirm Password"}{" "}
                <span className="text-danger">*</span>
              </label>
              <input
                type={showPasswords.field2 ? "text" : "password"}
                name="password2"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_password?.label_value || "Enter Password"
                }
                required
                value={userData.confirmPassword}
                onChange={(e) =>
                  updateUserData("confirmPassword", e.target.value)
                }
              />
              <span
                className="toggle-password position-absolute eye-icon"
                onClick={() => togglePassword("field2")}
              >
                <i
                  className={`fa ${showPasswords.field2 ? "fa-eye" : "fa-eye-slash"
                    }`}
                ></i>
              </span>
            </div>
          </div>

          <br />
          <div className="mt-3 text-center">
            <button onClick={resetPassword} className="btn btn-primary">
              {authLabel?.submit?.label_value || "Submit"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangePassword;
